import { login as loginEn } from './en/login.locale';
import { login as loginVi } from './vi/login.locale';
import { login as loginJp } from './jp/login.locale';
import { login as loginKo } from './ko/login.locale';
import { login as loginRu } from './ru/login.locale';
import { login as loginZh } from './zh/login.locale';
import { register as registerEn } from './en/register.locale';
import { register as registerVi } from './vi/register.locale';
import { register as registerJp } from './jp/register.locale';
import { register as registerRu } from './ru/register.locale';
import { register as registerKo } from './ko/register.locale';
import { register as registerZh } from './zh/register.locale';
import { otp as otpEn } from './en/otp.locale';
import { otp as otpVi } from './vi/otp.locale';
import { otp as otpJp } from './jp/otp.locale';
import { otp as otpRu } from './ru/otp.locale';
import { otp as otpKo } from './ko/otp.locale';
import { otp as otpZh } from './zh/otp.locale';
import { forgotPassword as forgotPasswordEn } from './en/forgotPassword.locale';
import { forgotPassword as forgotPasswordVi } from './vi/forgotPassword.locale';
import { forgotPassword as forgotPasswordJp } from './jp/forgotPassword.locale';
import { forgotPassword as forgotPasswordRu } from './ru/forgotPassword.locale';
import { forgotPassword as forgotPasswordKo } from './ko/forgotPassword.locale';
import { forgotPassword as forgotPasswordZh } from './zh/forgotPassword.locale';
import { resetPassword as resetPasswordEn } from './en/resetPassword.locale';
import { resetPassword as resetPasswordVi } from './vi/resetPassword.locale';
import { resetPassword as resetPasswordJp } from './jp/resetPassword.locale';
import { resetPassword as resetPasswordRu } from './ru/resetPassword.locale';
import { resetPassword as resetPasswordKo } from './ko/resetPassword.locale';
import { resetPassword as resetPasswordZh } from './zh/resetPassword.locale';
import { verification as verificationEn } from './en/verification.locale';
import { verification as verificationVi } from './vi/verification.locale';
import { verification as verificationJp } from './jp/verification.locale';
import { verification as verificationRu } from './ru/verification.locale';
import { verification as verificationKo } from './ko/verification.locale';
import { verification as verificationZh } from './zh/verification.locale';
export const authLocale = {
    en: {
        login: loginEn,
        register: registerEn,
        otp: otpEn,
        forgotPassword:forgotPasswordEn,
        resetPassword: resetPasswordEn,
        verification: verificationEn
    },
    vi: {
        login: loginVi,
        register: registerVi,
        otp: otpVi,
        forgotPassword: forgotPasswordVi,
        resetPassword: resetPasswordVi,
        verification: verificationVi
    },
    jp: {
        login: loginJp,
        register: registerJp,
        otp: otpJp,
        forgotPassword: forgotPasswordJp,
        resetPassword: resetPasswordJp,
        verification: verificationJp,
    },
    ru: {
        login: loginRu,
        register: registerRu,
        otp: otpRu,
        forgotPassword: forgotPasswordRu,
        resetPassword: resetPasswordRu,
        verification: verificationRu,
    },
    ko: {
        login: loginKo,
        register: registerKo,
        otp: otpKo,
        forgotPassword: forgotPasswordKo,
        resetPassword: resetPasswordKo,
        verification: verificationKo,
    },
    zh: {
        login: loginZh,
        register: registerZh,
        otp: otpZh,
        forgotPassword: forgotPasswordZh,
        resetPassword: resetPasswordZh,
        verification: verificationZh,
    },
};
